import { G } from '@/_common';

export const user_stores = {
    data: {
        wishlist: []
    },
    api: {
        langs:                              'v1/frontend/{lang}/langs',
        translations:                       'v1/frontend/{lang}/translations',

        system_settings:                    'v1/frontend/{lang}/system/{key}',

        menus:                              'v1/frontend/{lang}/menus',
        banners:                            'v1/frontend/{lang}/banners',
        statistics:                         'v1/frontend/{lang}/statistics',

        doyouknow:                          'v1/frontend/{lang}/doyouknow',
        manufacturers:                      'v1/frontend/{lang}/manufacturers',

        category_by_id:                     'v1/frontend/{lang}/category/{category_id}',
        categories_parent:                  'v1/frontend/{lang}/parent_categories',
        categories_with_children:           'v1/frontend/{lang}/categories_children',

        filters:                            'v1/frontend/{lang}/filters',
        products_list:                      'v1/frontend/{lang}/products',
        product_by_id:                      'v1/frontend/{lang}/product/{product_id}',
        products_by_category:               'v1/frontend/{lang}/products/{category_id}',
        // products_by_name:                   'v1/frontend/{lang}/products_by_name/{name}',
        products_by_page:                   'v1/frontend/{lang}/products_paging/{category_id}/{page}/{perpage}/{year_min}/{year_max}/{quarters}/{price_min}/{price_max}/{sortfield}/{sortorder}/{filters}?search_text={search_text}',
        products_similar:                   'v1/frontend/{lang}/similar_products/{product_id}/{category_id}',
    },

    getters: {
        // ---------------------------------------------------------------------------------------------
        getTranslations: (state) => () => {
            return state.api.translations.replace('{lang}', state.lang);
        },

		// initializeWishlist({ commit }) {
        //     const wishlistFromStorage = localStorage.getItem('wishlist');
        //     if (wishlistFromStorage) {
        //         commit('SET_WISHLIST', JSON.parse(wishlistFromStorage));
        //     }
        // },
        // addToWishlist({ commit }, product) {
        //     commit('ADD_TO_WISHLIST', product);
        // },
        // removeFromWishlist({ commit }, productId) {
        //     commit('REMOVE_FROM_WISHLIST', productId);
        // },
		// fetchMenuList({ commit }) {
        //     const apiURL = `${G.ajaxBaseUrl}/api/api.php?param=navigator`;
        //     fetch(apiURL)
        //         .then(response => response.json())
        //         .then(data => {
        //             commit('SET_MENU_LIST', data);
        //         })
        //         .catch(error => console.error('Error fetching menu list:', error));
        // },
		// fetchFooterAbout({ commit }) {
        //     const apiURL = `${G.ajaxBaseUrl}/api/api.php?param=about_footer`;
        //     fetch(apiURL)
        //         .then(response => response.json())
        //         .then(data => {
        //             commit('SET_FOOTER_ABOUT', data);
        //         })
        //         .catch(error => console.error('Error fetching menu list:', error));
        // },
		// fetchContactData({ commit }) {
        //     const apiURL = `${G.ajaxBaseUrl}/api/api.php?param=contact`;
        //     fetch(apiURL)
        //         .then(response => response.json())
        //         .then(data => {
        //             commit('SET_CONTACT_DATA', data);
        //         })
        //         .catch(error => console.error('Error fetching menu list:', error));
        // },

        addToWishlist: (state) => (product) => {
            if (!state.data.wishlist.some(p => p.id === product.id)) {
                state.data.wishlist.push(product);
                G.setClientData('wishlist', JSON.stringify(state.data.wishlist));
            }
		},
        removeFromWishlist: (state) => (productId) => {
            state.data.wishlist = state.data.wishlist.filter(p => p.id !== productId);
            G.setClientData('wishlist', JSON.stringify(state.data.wishlist));
        },

        // ---------------------------------------------------------------------------------------------

        getSystemSettings: (state) => (key = 'system') => {
            return state.api.system_settings.replace('{lang}', state.lang).replace('{key}', key);
        },
        getLangs: (state) => () => {
            return state.api.langs.replace('{lang}', state.lang);
        },
        getMenus: (state) => () => {
            return state.api.menus.replace('{lang}', state.lang);
        },
		getBanners: (state) => () => {
			return state.api.banners.replace('{lang}', state.lang);
		},
		getStatistics: (state) => () => {
			return state.api.statistics.replace('{lang}', state.lang);
		},
		getDoyouknow: (state) => () => {
			return state.api.doyouknow.replace('{lang}', state.lang);
		},
		getManufacturers: (state) => () => {
			return state.api.manufacturers.replace('{lang}', state.lang);
		},

		getCategoryById: (state) => (category_id) => {
			return state.api.category_by_id.replace('{lang}', state.lang).replace('{category_id}', category_id);
		},
		getCategories: (state) => () => {
			return state.api.categories_parent.replace('{lang}', state.lang);
		},
		getCategoriesWithChildren: (state) => () => {
			return state.api.categories_with_children.replace('{lang}', state.lang);
		},
        getFilters: (state) => () => {
            return state.api.filters.replace('{lang}', state.lang);
        },

        getProductsCategory: (state) => () => {
            return state.api.products_category.replace('{lang}', state.lang);
        },
        getProductsCategoryUpdate: (state) => (product_category_id) => {
            return state.api.products_category_update.replace('{lang}', state.lang).replace('{product_category_id}', product_category_id);
        },

        getProductById: (state) => (product_id) => {
            if( product_id === undefined ){
                product_id = 0;
            }
            return state.api.product_by_id.replace('{lang}', state.lang).replace('{product_id}', product_id);
        },
        getProductsByCategory: (state) => (category_id) => {
            if( category_id === undefined ){
                category_id = 0;
            }
            return state.api.products_by_category.replace('{lang}', state.lang).replace('{category_id}', category_id);
        },
        getProductsList: (state) => () => {
            return state.api.products_list.replace('{lang}', state.lang);
        },
        getProductsByName: (state) => (name) => {
            return state.api.products_by_category.replace('{lang}', state.lang).replace('{name}', name);
        },
        // getProductsPaging: (state) => (category_id) => {
        getProductsPaging: (state) => (data) => {
            // if( category_id === undefined ){
            //     category_id = 0;
            // }
            let s = state.api.products_by_page.replace('{lang}', state.lang);
            for( let a in data ){
                s = s.replace(`{${a}}`, data[a]);
            }
            // for( let a in data.query ){
            //     s = s.replace(`{${a}}`, data.query[a]);
            // }
            return s;
        },
        getProductsSimilarByCategory: (state) => (product_id, category_id) => {
            if( category_id === undefined ){
                category_id = 0;
            }
            if( product_id === undefined ){
                product_id = 0;
            }
            return state.api.products_similar.replace('{lang}', state.lang).replace('{product_id}', product_id).replace('{category_id}', category_id);
        },
    },
    // actions: {
    //     //
    // }

};
